import React,{useState,useEffect} from 'react'
import { CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useAlert } from '../../../context/AlertContext';
import { KeyOutlined, Phone } from '@mui/icons-material';
import customerOtpServices from '../../customerOtpServices';
import { useNavigate } from 'react-router-dom';





function RequestPhoneNo({requestStatus, callback, canSkip=true}) {
    
    const {AppAlert} = useAlert();
    const navigate = useNavigate();

    const [customerPhone,setCustomerPhone] = useState(localStorage.getItem("customerPhone")); 

    const [loading,setLoadingStatus] = useState(false);
    const [phoneNoInput,setPhoneNoInput] = useState("");
    const [otpInput,setOtpInput] = useState("");
    const [otpSent,setOtpSent] = useState(false);
    const [resendTimer,setResendTimer] = useState(0);
    
    const [dialogStatus, setDialogStatus] = useState(false);

    useEffect(()=>{
        console.log("customer");
        console.log(customerPhone);
        console.log("resuestStatus");
        console.log(requestStatus);
        if(requestStatus && customerPhone === null){
            setDialogStatus(true);
        } else {
            callback(customerPhone)
        }
	},[customerPhone,requestStatus])


    
    const requestOtp = () =>{
        setLoadingStatus(true);
        customerOtpServices.requestSMSOtp({phone:phoneNoInput}).then(res=>{
            setOtpSent(true);
            setResendTimer(60);
        }).catch(()=>{

        }).finally(()=>{
            setLoadingStatus(false)
        })
    }

    const verifyOtp = () =>{
        setLoadingStatus(true);
        let payload = {
            phone:phoneNoInput,
            otp:otpInput,
        }
        customerOtpServices.verifySMSOtp(payload).then(res=>{
            //setCustomerToken(res.data.token)
            localStorage.setItem("customerPhone",res.data.token);
            localStorage.setItem("guestPhone",res.data.guestPhone);

            setCustomerPhone(res.data.token)
            setDialogStatus(false)
        }).catch((error)=>{
            AppAlert("Invalid OTP","error")
        }).finally(()=>{
            setLoadingStatus(false)
        })
    }

    /*
    const handlePhoneNoChange = () =>{
		if(phoneNoInput.length !== 10){
			AppAlert("Invalid Phone Number","error");
			return false;
		}
		let phoneNo = "91"+phoneNoInput;
        localStorage.setItem("customerPhone",phoneNo);
        callback(phoneNo);
    }
    */

    return (
        <>
            <Dialog
				open={dialogStatus}
				keepMounted
				//onClose={()=>setDialogStatus(false)}
				maxWidth="sm"
				fullWidth={true}
			>
                <DialogTitle>Your Phone No to Continue.</DialogTitle>
                <DialogContent>
                    
                        {!otpSent &&
                            <div className='row mt-3'>
                                <div className='col-md-12'>
                                    <div className="input-group mb-3">
                                        <span className="input-group-text"><Phone /></span>
                                        <input type="number" className="form-control" placeholder="Your Phone Number" 
                                            value={phoneNoInput}
                                            onChange={(e)=>setPhoneNoInput(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                        {otpSent && 
                            <div className='row mt-3'>
                                <div className='col-md-12 mb-3'>
                                    <div className='border rounded p-2 text-success text-center'>Otp Sent on {phoneNoInput}</div>
                                </div>
                                <div className='col-md-12'>
                                    <div className="input-group mb-3">
                                        <span className="input-group-text"><KeyOutlined/></span>
                                        <input type="number" className="form-control" placeholder="Enter Otp" 
                                            value={otpInput}
                                            onChange={(e)=>setOtpInput(e.target.value)}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                </DialogContent>
                <DialogActions>
                    {!canSkip &&
                        <button onClick={()=>navigate(-1)} className='btn btn-outline-primary'>Cancel</button>
                    }
                    {!otpSent ?
                        <button disabled={phoneNoInput.length !== 10} onClick={requestOtp} className='btn btn-primary'>Continue</button>
                        :
                        <button disabled={otpInput.length !== 4} onClick={verifyOtp} className='btn btn-primary'>Verify Otp</button>
                    }
                </DialogActions>
            </Dialog>
        </>
    )
}

export default RequestPhoneNo